<body>
  <div class="wraper">
    <div id="particles-js"></div>
    <div class="bg_main"></div>
    <div class="space">
      <div class="row align-items-center fade_one">
        <div class="col-lg-7">
          <div class="main_left">
            <div class="row align-items-center justify-content-between">
              <div class="col-lg-10">
                <div class="logo">
                  <img
                    src="{{ onPassiveBaseUrl }}onpassive(nov-9)/images/logo.png"
                    alt="logo"
                  />
                </div>
                <div class="left_box">
                  <h1 class="ml15">
                    <span class="word">LAUNCHING</span>
                    <span class="word">SOON!</span>
                  </h1>
                  <p>
                    If you can dream it, you can achieve it! We at ONPASSIVE
                    take this very seriously because we understand the urge to
                    taste success. Our business models are handcrafted by
                    artificial intelligence to bring dreams into reality.
                  </p>

                  <a
                    href="/registration/user?reg={{ userId }}"
                    name="regform"
                    target="_blank"
                    rel="noopener"
                    class="become_button"
                    >Become a Founder Now</a
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-5">
          <div class="row">
            <div class="col-lg-12">
              <div class="right_box left">
                <div class="top_floating">
                  <h3>NEW REVOLUTIONIZED INTERNET MARKETING SOLUTIONS</h3>
                </div>
                <div class="video_box acc_panel anim_in">
                  <video
                    id="my-video"
                    class="video-js video-size w-100 h-auto"
                    controls
                    preload="auto"
                    poster="{{ myLinksS3URL }}images/Image0231.png"
                    data-setup="{}"
                    autoplay="true"
                    muted
                  >
                    <source
                      src="{{
                        myLinksS3URL
                      }}videos/Onpassive_launching_page_video2.mp4"
                      type="video/mp4"
                    />
                  </video>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</body>
